import { useMutation, UseMutationResult } from '@tanstack/react-query';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common';
import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1';
import { UpdateProgrammeUserDto } from '@dealstack/shared/lib/generated';
import { ServiceRequestOptions } from '@dealstack/frontend/shared/other/react/ApiWrapper/types';

const updateProgrammeUser = async ({
	isContactPerson,
	firstName,
	lastName,
	userId,
	programmeId,
	options,
}: {
	userId: string;
	programmeId: string;
	options?: ServiceRequestOptions;
} & UpdateProgrammeUserDto) => {
	const response = await makeRequest<ApiV1.Response<UpdateProgrammeUserDto>>(
		{
			endpoint: formatUnicorn(API_PATHS.MIP_PROGRAMMEID_USERS_USERID_PUT, {
				userId,
				programmeId,
			}),
			method: HTTP_METHOD.PUT,
			body: JSON.stringify({
				isContactPerson,
				firstName,
				lastName,
			}),
		},
		{ ...options }
	);
	return response;
};

export const useUpdateProgrammeUser = (): UseMutationResult<
	ApiV1.Response<UpdateProgrammeUserDto>,
	unknown,
	{
		programmeId: string;
		userId: string;
		options?: ServiceRequestOptions;
	} & UpdateProgrammeUserDto
> => {
	return useMutation({
		mutationFn: updateProgrammeUser,
	});
};
